import { ACCOUNT_INITIALISE,ACCOUNT_CONFIG, ACCOUNT_PERSPECTIVE, LOGIN, LOGOUT } from "./actions";

const accountReducer = (state, action) => {
    switch (action.type) {
        case ACCOUNT_INITIALISE: {
            const { isLoggedIn, user,config,isAdmin } = action.payload;
            return {
                ...state,
                isLoggedIn,
                isInitialised: true,
                isAdmin,
                user,
                config
            };
        }
        case ACCOUNT_CONFIG: {
            const { config } = action.payload;
            return {
                ...state,
                config
            };
        }
        case LOGIN: {
            const { user } = action.payload;
            return {
                ...state,
                isLoggedIn: true,
                user
            };
        }
        case LOGOUT: {
            return {
                ...state,
                isLoggedIn: false,
                user: null
            };
        }
        case ACCOUNT_PERSPECTIVE:{
            const { perspective } = action.payload;
            return {
                ...state,
                perspective
            }
        }
        default: {
            return { ...state };
        }
    }
};

export default accountReducer;